import { Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { AuthGate } from '@/components/auth/auth-gate'

/**
 * 路由 devtools 挂不挂。
 *
 * ⚠⚠ **自动化环境下一律不挂**（`navigator.webdriver`）。由来：那个悬浮按钮在
 *   **390px** 下正好盖在「发送」上，点不动 —— 桌面上撞不到（内容居中，发送键在中间偏右，
 *   而按钮贴着屏幕最右下角），所以一直没人发现。
 * ⚠ 换个角解决不了：手机上四个角都被占（顶部是标题与「我的」，底部是输入区）。
 * ⚠ 只对自动化关掉，人开着 dev server 时行为一个字没变 —— 这不是把工具拿走，
 *   是不让它去挡被测对象。
 */
const showDevtools = import.meta.env.DEV && !navigator.webdriver

/**
 * 全局布局。路由文件只声明路由，组件一律放这里 ——
 * 一是 fast refresh 要求文件导出的是组件，二是路由文件保持薄一层好读。
 *
 * ⚠ AuthGate 包在 Outlet 外面：登录面板是覆盖层而不是页面，
 *   因为「登录后原地恢复」要求当前页面不能被卸载。
 */
export function RootLayout() {
  return (
    <AuthGate>
      <Outlet />
      {showDevtools ? <TanStackRouterDevtools position="bottom-right" /> : null}
    </AuthGate>
  )
}
